import { memo, useEffect } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { useHistory } from 'react-router'

import { usePostMessage, PostMessageType } from 'hooks'
import { CenterDiv } from 'components/ui/Shared'
import InfoMessage from 'components/ui/InfoMessage'
import { useTranslation } from 'hooks/useTranslation'
import { useAuth } from 'api'

import { PAYMENT_EVENT_NAME, PAYMENT_EVENT_SOURCE } from './PaymentRedirect.config'

import { PaymentRedirectProps } from '.'

const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

const isSameDomain = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    window.parent.document
    return true
  } catch (e) {
    return false
  }
}

function PaymentRedirect({ transactionPageUrl, ...rest }: PaymentRedirectProps): JSX.Element {
  const { t } = useTranslation()
  const { isLoading: isLoadingAuth } = useAuth()

  const history = useHistory()

  const { isError, isLoading } = usePostMessage(
    PostMessageType.iframe,
    inIframe()
      ? {
          source: PAYMENT_EVENT_SOURCE,
          event: PAYMENT_EVENT_NAME,
          payload: undefined,
        }
      : undefined,
  )

  useEffect(() => {
    // the redirect page is not inside iframe, make redirect to the transaction page
    if (inIframe()) {
      if (isSameDomain()) {
        if (window.location === window.parent.location) {
          history.replace(transactionPageUrl)
        }
      } else {
        history.replace(transactionPageUrl)
      }
    } else {
      // hook to test locally
      // const [domain, path] = transactionPageUrl.split('/buy/')
      if (!isLoadingAuth) {
        // if (domain && domain !== 'http://localhost:3000') {
        //   window.location.href = `http://localhost:3000/r/${path}`
        //   return
        // }

        history.replace(transactionPageUrl)
      }
    }
    return
  }, [history, transactionPageUrl, isLoadingAuth])

  return (
    <CenterDiv style={{ padding: '1rem' }} {...rest}>
      {isLoadingAuth || isLoading ? (
        <CircularProgress />
      ) : isError ? (
        <InfoMessage title={t('paymentRedirect.errorMsg')} nature='error' />
      ) : (
        <InfoMessage title={t('paymentRedirect.successMsg')} nature='success' />
      )}
    </CenterDiv>
  )
}

export default memo(PaymentRedirect)
